function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave14(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fbf6fb3c-c43f-46eb-bb90-36ef6e3d4e40",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "e08eafdb-0712-4343-a94f-82b37e07ccf7",
    "data-name": "Wave-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab6caabc-4ece-44ea-9e55-3d8f00336c90",
    "data-name": "Rectangle-Copy-6",
    d: "M1366,48H0V.02762C125.5106-1.33268,696.561,48,1067,48Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave14;